// Note that all user permissions are inherited by admins
const user_permission = {
  role: "user",
  is_user: true,
  user: true,
  link: true,
  organizations: {
    show: true
  },
  users: {
    me: true,
    update: true
  },
  contact_manager: {
    show: true
  },
  contacts: {
    show: true,
    import: true,
    save_as_segment: true
  },
  segments: {
    show: true,
    save: true,
    create: true,
    new: true,
    delete: true,
    list: true,
    open: true,
    update: true,
    search: true
  },
  companies: {
    show: true,
    create: true,
    delete: true,
  },
  projects: {
    list: true,
    show: true,
    statistics: true,
    search: true
  },
  projects: {
    list: true,
    show: true,
    statistics: true,
    search: true
  },
  project_leads: {
    list: true,
    create: true,
    add_popup: true,
    new: true,
    create_from_businesscard: true,
    update: true,
    show: true,
    search: true,
    download_pdf: true
  },
  eventbaxx_events: {
    list: true,
    show: true,
    send: true
  },
  statistics: {
    projects: true
  }
};

// Admins inherit all user permissions, so there is no need to include them here again
const admin_permission = {
  role: "admin",
  admin: true,
  is_admin: true,
  is_user: true,
  link: true,
  organizations: {
    create: false,
    delete: true,
    disable: false,
    enable: false,
    list: false,
    show: true,
    update: true,
    search: true
  },
  users: {
    create: false,
    delete: true,
    disable: true,
    invite: true,
    list: true,
    me: true,
    show: true,
    update: true,
    invite_xls: true,
    update_status: false,
    update_role: true,
    search: true
  },
  lead_masks: {
    list: true,
    create: true,
    update: true,
    new: true,
    show: true,
    search: true
  },
  projects: {
    assign_users: true,
    close: true,
    create: true,
    new: true,
    delete: true,
    open: true,
    unassign_users: true,
    update: true,
    options: true,
    synchronize: true,
    search: true
  },
  lead_masks: {
    list: true,
    create: true,
    update: true,
    new: true,
    show: true,
    search: true,
    add_popup: true
  },
  lead_mask: {
    save: true,
    publish: true
  },
  project_leads: {
    list: true,
    add_popup: true,
    create_from_businesscard: true,
    update: true,
    create: true,
    export: true,
    new: true,
    show: true,
    update_date: true,
    update_user: true,
    search: true,
    download_pdf: true
  },
  business_kits: {
    list: true
  },
  project_business_kits: {
    list: true
  },
  external_forms: {
    list: true,
    create: true,
    update: true,
    new: true,
    show: true,
    search: true
  },
  external_form: {
    add_popup: true,
    save: true,
    publish: true
  },
  statistics: {
    list: false
  },
  email_templates: {
    list: true,
    create: true,
    new: true,
    update: true,
    search: true
  },
  workflows: {
    add_popup: true,
    trigger: true,
    list: true,
    create: true,
    new: true,
    update: true,
    search: true
  }
};

const root_permission = {
  role: "root",
  is_root: true
};

export { user_permission, admin_permission, root_permission };



// WEBPACK FOOTER //
// ./src/config/static_permissions.js